import { render, staticRenderFns } from "./regisInfoOutside.vue?vue&type=template&id=15b73a64&scoped=true"
import script from "./regisInfoOutside.vue?vue&type=script&lang=js"
export * from "./regisInfoOutside.vue?vue&type=script&lang=js"
import style0 from "./regisInfoOutside.vue?vue&type=style&index=0&id=15b73a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b73a64",
  null
  
)

export default component.exports